var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"video-player"},[_c('div',{ref:"playerWrap"}),_c('div',{ref:"interactWrap",attrs:{"id":"interactWrap"}},[(_vm.curEvent)?_c('div',{staticClass:"interact-wrap",style:(_vm.interactWrapStyle)},[_c(_vm.curInteract,{tag:"component",attrs:{"event":_vm.curEvent},on:{"end":_vm.posEnd,"realEnd":_vm.interactPlay}})],1):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }